export default {
  'assets.selector.title': 'Select reference {type}',
  'assets.selector.type.image': 'image',
  'assets.selector.type.video': 'video',
  'assets.selector.localUpload': 'Upload from local',
  'assets.selector.tab.upload': 'Upload assets',
  'assets.selector.tab.ai': 'AI generated',
  'assets.selector.loading': 'Loading...',
  'assets.selector.deleteConfirm.title': 'Delete asset?',
  'assets.selector.deleteConfirm.content': 'This action cannot be undone.',
  'assets.selector.deleteConfirm.ok': 'Delete',
  'assets.selector.deleteConfirm.cancel': 'Cancel',
  'assets.selector.uploading': 'Uploading...',
  'assets.selector.uploadSuccess': 'Uploaded successfully',
  'assets.selector.uploadFailed': 'Upload failed. Please try again.',
  'assets.selector.uploadNoWorkspace': 'No workspace found. Please sign in first.',
  'assets.selector.loadFailed': 'Failed to load assets',
  'assets.selector.deleteSuccess': 'Deleted successfully',
  'assets.selector.deleteFailed': 'Delete failed. Please try again.',
};

